
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.753 25H6.841c-.6 0-1.104-.444-1.188-1.032L3.397 8.2h16.8l-2.256 15.768A1.202 1.202 0 0116.753 25zM1.603 8.2h20.4M9.397 13v7.2M14.2 13v7.2M16.6 4.6H7l2.04-3.06c.228-.336.6-.54 1.008-.54h3.516c.396 0 .78.204.996.54L16.6 4.6zM1 4.6h21.6","stroke":"#221B38","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    